import React from 'react';
import { bool } from 'prop-types';
import { useTheme } from '@thd-olt-component-react/theme-provider';
import { Add, Heart } from '@one-thd/sui-icons';
import { Typography, Button } from '~/@one-thd/sui-atomic-components';

export const ListNotFoundMessaging = (props) => {
  const { isSharedList } = props;

  const theme = useTheme(ListNotFoundMessaging, props);
  const { showPlusSign } = theme.props;
  const icon = showPlusSign ? { name: 'Plus' } : { name: 'Heart' };

  return (
    <div className="sui-mx-auto sui-w-fit sui-bg-primary sui-p-4 sui-text-center">
      {
        showPlusSign ? (
          <Add
            alt="add-icon"
          />
        ) : (
          <Heart
            alt="heart-icon"
          />
        )
      }
      <Typography variant="h3" weight="display">
        { isSharedList ? 'List is empty or no longer exists' : 'This list no longer exists' }
      </Typography>
      <Typography variant="body-base">
        See something you like? Select the {icon.name} icon to save it to a list.
      </Typography>
      <div className="sui-my-4">
        <Button href="/" component="a">Start Shopping</Button>
      </div>
    </div>
  );

};

ListNotFoundMessaging.displayName = 'ProductListNotFoundMessaging';

ListNotFoundMessaging.propTypes = {
  isSharedList: bool
};

ListNotFoundMessaging.defaultProps = {
  isSharedList: false
};

ListNotFoundMessaging.themeProps = {
  showPlusSign: bool
};

ListNotFoundMessaging.defaultThemeProps = {
  showPlusSign: false
};
